import {Flex, Text} from '@chakra-ui/react';
import {FC} from 'react';
import ImageUI from 'ui/ImageUI';

interface IProps {
  icon: string;
  title: string;
}

export const NotFoundBanner: FC<IProps> = ({title, icon}) => {
  return (
    <Flex py={['50px', '120px']} justifyContent="center" alignItems="center" flexDirection="column">
      <ImageUI src={icon} alt="not found search" />
      <Text>{title}</Text>
    </Flex>
  );
};
